import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  Button,
  useColorModeValue,
} from '@chakra-ui/react';
import { useState } from 'react';

function ContactSection() {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    mensaje: '',
  });

  const cardBg = useColorModeValue('rgba(255, 255, 255, 0.8)', 'rgba(15, 23, 42, 0.6)');
  const cardBorder = useColorModeValue('gray.200', 'whiteAlpha.200');
  const subtitleColor = useColorModeValue('gray.600', 'gray.300');
  const inputBg = useColorModeValue('white', 'rgba(15, 23, 42, 0.8)');
  const inputBorder = useColorModeValue('gray.300', 'whiteAlpha.300');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleWhatsAppClick = () => {
    const { nombre, email, mensaje } = formData;

    let whatsappMessage = 'Hola, necesito información para traer productos del exterior.';

    if (nombre || email || mensaje) {
      whatsappMessage = `Hola, me gustaría solicitar información:\n\n`;

      if (nombre) {
        whatsappMessage += `*Nombre:* ${nombre}\n`;
      }

      if (email) {
        whatsappMessage += `*Email:* ${email}\n`;
      }

      if (mensaje) {
        whatsappMessage += `\n*Mensaje:*\n${mensaje}`;
      }
    }

    const encodedMessage = encodeURIComponent(whatsappMessage);
    const whatsappUrl = `https://api.whatsapp.com/send?phone=573133203931&text=${encodedMessage}`;

    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <Box id="contacto" as="section" w="full">
      <Container maxW="1120px" px={{ base: 4, md: 6, lg: 8 }}>
        <Flex
          direction={{ base: 'column', lg: 'row-reverse' }}
          gap={{ base: 6, md: 8, lg: 10 }}
          align="center"
        >
          {/* Text Content & Form - 60% */}
          <VStack align="start" spacing={{ base: 4, md: 6 }} flex="0 0 100%" maxW={{ lg: '100%' }}>
            <Heading 
              as="h2" 
              fontSize={{ base: '3xl', md: '4xl', lg: '5xl' }}
              fontWeight={900} 
              lineHeight="1.2"
            >
              ¿Listo para importar tu próximo proyecto?
            </Heading>
            <Text
              fontSize={{ base: 'lg', md: 'xl' }}
              color={subtitleColor}
              letterSpacing="wide"
              lineHeight="tall"
              pb={3}
              mb={2}
            >
              Cuéntanos qué necesitas importar y te asesoramos sin compromiso sobre costos, tiempos y requisitos.
            </Text>

            <Box
              as="form"
              bg={cardBg}
              p={{ base: 4, md: 6 }}
              borderRadius="xl"
              border="1px solid"
              borderColor={cardBorder}
              w="full"
            >
              <VStack spacing={{ base: 3, md: 4 }}>
                <FormControl>
                  <FormLabel fontSize={{ base: 'xs', md: 'sm' }}>Nombre</FormLabel>
                  <Input
                    type="text"
                    name="nombre"
                    placeholder="Tu nombre"
                    value={formData.nombre}
                    onChange={handleInputChange}
                    bg={inputBg}
                    border="1px solid"
                    borderColor={inputBorder}
                    borderRadius="lg"
                    fontSize={{ base: 'sm', md: 'base' }}
                    py={{ base: 2, md: 2.5 }}
                    _placeholder={{ color: 'gray.500' }}
                  />
                </FormControl>

                <FormControl>
                  <FormLabel fontSize={{ base: 'xs', md: 'sm' }}>Email</FormLabel>
                  <Input
                    type="email"
                    name="email"
                    placeholder="tucorreo@email.com"
                    value={formData.email}
                    onChange={handleInputChange}
                    bg={inputBg}
                    border="1px solid"
                    borderColor={inputBorder}
                    borderRadius="lg"
                    fontSize={{ base: 'sm', md: 'base' }}
                    py={{ base: 2, md: 2.5 }}
                    _placeholder={{ color: 'gray.500' }}
                  />
                </FormControl>

                <FormControl>
                  <FormLabel fontSize={{ base: 'xs', md: 'sm' }}>Mensaje</FormLabel>
                  <Textarea
                    name="mensaje"
                    rows={{ base: 3, md: 4 }}
                    placeholder="Cuentanos que necesitas"
                    value={formData.mensaje}
                    onChange={handleInputChange}
                    bg={inputBg}
                    border="1px solid"
                    borderColor={inputBorder}
                    borderRadius="lg"
                    fontSize={{ base: 'sm', md: 'base' }}
                    py={{ base: 2, md: 2.5 }}
                    _placeholder={{ color: 'gray.500' }}
                  />
                </FormControl>

                <Button
                  onClick={handleWhatsAppClick}
                  variant="primary"
                  w="full"
                  type="button"
                  fontSize={{ base: 'sm', md: 'base' }}
                  py={{ base: 2, md: 2.5 }}
                >
                 Hablar con un asesor por WhatsApp
                </Button>
              </VStack>
            </Box>
          </VStack>

          
        </Flex>
      </Container>
    </Box>
  );
}

export default ContactSection;
